import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="regulatory_updates" pageTitle="法规更新" pageDescription="及时了解影响制药、医疗器械和体外诊断领域的法规变化——对新指南和立法的专家分析。" />;

export const Route = createFileRoute("/zh-cn/regulatory-updates/")({
  head: () => buildRouteHead("/zh-cn/regulatory-updates"),
  component: ContentListingRoute,
});

